var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterrupt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.1 3.979-4.459 7.03a.952.952 0 0 0-.003.99c.091.15.222.276.38.364a1.1 1.1 0 0 0 .523.137h8.918a1.1 1.1 0 0 0 .522-.137c.159-.088.29-.214.38-.365a.951.951 0 0 0-.002-.99L8.9 3.978a1.028 1.028 0 0 0-.383-.35 1.101 1.101 0 0 0-1.034 0c-.157.084-.29.205-.383.35v0zM8 6.534v1.989M8 10.511h.005"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrupt);
export default __webpack_public_path__ + "static/media/interrupt.c6b4158779d8f55ceadd59e2f4e747c8.svg";
export { ForwardRef as ReactComponent };